<button [matMenuTriggerFor]="userActions"
    class="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 hover:bg-slate-100 dark:hover:bg-slate-800 h-10 py-2 gap-2 px-2"
    type="button">
    <div class="relative w-8 h-8 rounded-full bg-orange-600 flex items-center justify-center shrink-0 overflow-hidden">
        @if (showAvatar && user?.urlImage) {
        <img class="h-full w-full object-cover" [src]="user?.urlImage" [alt]="user?.name" />
        } @else {
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
            class="w-4 h-4 text-white">
            <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"></path>
            <circle cx="12" cy="7" r="4"></circle>
        </svg>
        }
    </div>

    <div class="hidden md:flex flex-col items-start leading-none gap-1">
        <span class="text-sm font-medium">{{ user?.name || 'Usuário' }}</span>
        <span class="text-xs text-slate-500 font-normal italic">Super Admin</span>
    </div>

    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
        stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
        class="lucide lucide-chevron-down w-4 h-4 text-slate-500 hidden md:block">
        <path d="m6 9 6 6 6-6"></path>
    </svg>
</button>

<mat-menu [xPosition]="'before'" #userActions="matMenu" panelClass="shadcn-menu-panel">
    <div class="px-2 py-1.5 text-sm font-semibold text-slate-900 dark:text-slate-100">
        Minha Conta
    </div>

    <div class="h-px bg-slate-200 dark:bg-slate-800 my-1 -mx-1"></div>

    <button mat-menu-item class="custom-item">
        <div class="flex items-center gap-2">
            <svg class="w-4 h-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round"
                    d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
            </svg>
            <span>Perfil</span>
        </div>
    </button>

    <button mat-menu-item (click)="config()" class="custom-item">
        <div class="flex items-center gap-2">
            <svg class="w-4 h-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round"
                    d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                <circle cx="12" cy="12" r="3" />
            </svg>
            <span>Configurações</span>
        </div>
    </button>

    <button mat-menu-item class="custom-item">
        <div class="flex items-center gap-2">
            <svg class="w-4 h-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round"
                    d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
            </svg>
            <span>Logs de Atividade</span>
        </div>
    </button>

    <div class="h-px bg-slate-200 dark:bg-slate-800 my-1 -mx-1"></div>

    <button mat-menu-item (click)="signOut()" class="custom-item !text-red-500 hover:!bg-red-50">
        <div class="flex items-center gap-2 font-medium">
            <svg class="w-4 h-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round"
                    d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
            </svg>
            <span>Sair</span>
        </div>
    </button>
</mat-menu>